var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldNoteSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.999 11.889-1.67-.55c-.58-.19-1.17-.12-1.62.2-.44.33-.7.86-.7 1.48v4.79c-.4-.22-.85-.36-1.34-.36a2.8 2.8 0 0 0-2.69 3.55 2.796 2.796 0 0 0 5.49-.69v-4.61c.02 0 .03.01.05.02l2.28.76c.04.01.09.03.13.03.18.05.34.07.51.07.36 0 .7-.1.98-.31.45-.32.7-.85.7-1.47v-.6c0-.91-.64-1.81-1.5-2.1l-.62-.21zm-6.43 9.11c-.15-.21-.23-.47-.23-.75a1.336 1.336 0 0 1 2.67 0c0 .23-.06.44-.16.62a1.326 1.326 0 0 1-2.28.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.119 14.799c0 .62-.25 1.15-.7 1.47-.28.21-.62.31-.98.31-.17 0-.33-.02-.51-.07-.04 0-.09-.02-.13-.03l-2.28-.76c-.02-.01-.03-.02-.05-.02v4.61a2.796 2.796 0 0 1-5.49.69 2.8 2.8 0 0 1 2.69-3.55c.49 0 .94.14 1.34.36v-4.79c0-.62.26-1.15.7-1.48.45-.32 1.04-.39 1.62-.2l1.67.55.62.21c.86.29 1.5 1.19 1.5 2.1v.6z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9.62c0 .34-.33.58-.66.47l-.54-.18c-1.05-.33-2.12-.19-2.99.43-.83.62-1.3 1.6-1.3 2.68v2.45c0 .27-.21.49-.48.53-2.06.31-3.65 2.1-3.65 4.25v.15c.01.31-.22.6-.54.6H7.52C4.07 21 2 18.94 2 15.48V7.52C2 4.06 4.07 2 7.52 2h7.96C18.93 2 21 4.06 21 7.52v2.1z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldNoteSquare);
export default __webpack_public_path__ + "static/media/vuesax-bold-note-square.ce337d996097907ef66cd286a4673b99.svg";
export { ForwardRef as ReactComponent };